import { Datasheet } from "@/api/datasheets";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";
import { WelderRow, WelderWeld } from "@/api/cds/rbi";

export type WeldListFilters = {
  onlyMyWelds: boolean;
  onlyWeldsNotMade: boolean;
  onlyRepairWelds: boolean;
};

export type WelderState = {
  project?: Project;
  subProject?: SubProject;
  datasheet?: Datasheet;
  welds: WelderWeld[];
  processes: WelderRow[];
  filters: WeldListFilters;
};

export const defaultFilters: WeldListFilters = {
  onlyMyWelds: false,
  onlyWeldsNotMade: true,
  onlyRepairWelds: false,
};

export const defaultState: WelderState = {
  welds: [],
  processes: [],
  filters: defaultFilters,
};

export type StateType = "Project" | "SubProject" | "Datasheet" | "Welds" | "Processes" | "Filters";
